<template>
	<transition name="custom-classes-transition" enter-active-class="animate__animated animate__bounceIn" leave-active-class="animate__animated animate__bounceOutUp">
		<div
			v-if="visible"
			:class="type || 'warning'"
			class="message-wrapper frame-panel d-flex align-items-stretch none-select shadow"
		>
			<div class="content text-pre-line flex-grow-1 text-center" :class="isClose ? 'has-close' : ''">{{ content }}</div>
			<div class="close-wrapper flex-hcvc" v-if="isClose" @click="visible = false">
				<svg-icon icon-class="close" class="close" />
			</div>
		</div>
	</transition>
</template>

<script setup>
import { ref, onMounted } from 'vue';

const content = ref('这是一条普通的消息');
const timeOut = ref(2000);
const visible = ref(true);
const type = ref('info'); // 默认是info, 可选 success、error、warning
const isClose = ref(false);

const close = () => {
	window.setTimeout(() => {
		visible.value = false;
	}, timeOut.value);
};

onMounted(() => {
	close();
});
</script>

<style lang="scss" scoped>
@use '@/styles/var.scss' as *;

.message-wrapper {
	position: fixed;
	z-index: $message-index;
	top: 5px;
	left: 5px;
	width: calc(100% - 10px);
	border-radius: $radius;
	overflow: hidden;

	.content {
		padding: .75rem;
	}
	.content.has-close {
		padding-right: 2rem;
	}

	.close-wrapper {
		@extend .click-animate;
		background-color: rgba(66,66,66,.1);
		padding: .5rem;
		.close {
			color: #999;
		}
	}
	.close-wrapper:hover {
		background-color: rgba(66,66,66,.15);
		padding: .5rem;
	}
}

@media(min-width:768px) {
	.message-wrapper {
		top: 2rem;
		left: calc(50% - 250px);
		width: 500px;
		.content {
			padding: 1rem;
		}
	}
}

.warning {
	background-color: $c-yellow !important;
	font-weight: bold;
}
.success {
	background-color: $c-green !important;
}
.error {
	background-color: $c-red !important;
	font-weight: bold;
}
.warning, .success, .error {
	color: $c-light !important;
	.close-wrapper {
		.close {
			color: rgba(255,255,255,1);
		}
	}
}
</style>
